import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';
import { AuthConfig, OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { IdexService } from 'app/idex.service';
import { AppComponent } from 'app/app.component';
import { Toast } from '../../shared/toast/toast';

@Component({
   selector: 'app-oauth',
   templateUrl: './oauth.component.html',
   styleUrls: ['./oauth.component.css']
})
export class OAuthComponent implements OnInit {
   error = '';
   account: any = {};
   private authenticating = false;

   constructor(private route: ActivatedRoute, private router: Router, private oauth: OAuthService,
               private service: IdexService, private app: AppComponent, private toast: Toast, private zone: NgZone) {
   }

   ngOnInit(): void {
      const provider = this.route.snapshot.params['provider'];
      if (!provider) {
         this.router.navigateByUrl('/login');
         return;
      }
      const device = this.route.snapshot.queryParams['device'];
      if (device === 'Mobile' && provider) {
         this.checkDevice('auth', provider);
         return;
      }
      // always start a fresh SSO session
      if (this.service.user?.token) {
         this.service.setUser();
      }
      setTimeout(() => this.init(provider), 200);
   }

   private checkDevice(path: string, id: string): void {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('iphone') > -1) {
         window.location.href = `idex://${path}?key=${id}`;
         setTimeout(() => {
            window.location.href = 'https://itunes.apple.com/app/zdox/id1436468541';
         }, 5000);
      } else if (userAgent.search('android') > -1) {
         window.location.href = `idex://${path}?key=${id}`;
         setTimeout(() => {
            window.location.href = `https://play.google.com/store/apps/details?id=com.ginkgosoft.idex&referrer=${path}?key=${id}`;
         }, 1000);
      } else {
         setTimeout(() => this.init(id), 200);
      }
   }

   private init(provider: string): void {
      this.service.get(`api/idp?name=${encodeURIComponent(provider)}`).subscribe(idp => {
         this.oauth.configure(this.authConfig(idp));
         this.oauth.loadDiscoveryDocumentAndLogin().catch(e => this.redirectToLogin(e));
         this.oauth.events.subscribe((event: OAuthEvent) => {
            if (event.type === 'token_received' || event.type === 'discovery_document_loaded') {
               const token = this.oauth.getIdToken();
               if (token) {
                  this.authenticate(provider, token);
               }
            }
         });
      }, e => this.redirectToLogin(e));
   }

   private authenticate(provider: string, token: string): void {
      if (this.authenticating) { return; }
      this.authenticating = true;
      const headers = new HttpHeaders()
         .set('Authorization', `Bearer ${token}`)
         .set('X-Identity-Provider', provider)
         .set('Content-Type', 'application/json;charset=utf-8');
      this.service.post('sso/login?device=Web', null, { headers }).subscribe(user => {
         this.zone.run(() => {
            this.service.setUser(user);
            this.service.setIdpLogin(true);
            this.app.setUser(user);
            this.router.navigate(['/dashboard']);
         });
      }, e => {
         this.zone.run(() => {
            this.authenticating = false;
            this.error = e.message;
            const claims: any = this.oauth.getIdentityClaims() || {};
            this.account.name = claims['name'];
            this.account.username = claims['preferred_username'] || claims['email'] || claims['upn'];
         });
      });
   }

   private authConfig(idp: any): AuthConfig {
      const url = location.origin + location.pathname;
      return {
         issuer: idp.issuer,
         clientId: idp.clientId,
         redirectUri: url,
         postLogoutRedirectUri: url,
         responseType: 'code',
         scope: 'openid profile email',
         showDebugInformation: false,
         strictDiscoveryDocumentValidation: false
      };
   }

   private redirectToLogin(e: any): void {
      this.toast.error(e?.message || 'Unable to start SSO login');
      this.router.navigateByUrl('/login');
   }
}
